exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".kb-field-19vn1Q{margin-bottom:8px}.kb-form-error-UcEzx8{width:100%;margin:-3px 0 5px 1px;color:#dc3545;font-size:14px}label.svelte-40mja3{font-size:14px}", ""]);
